export default __webpack_public_path__ + "static/media/mobile_menu_close.1d1a0088.svg";